<template>
    <label :for="name">
        <div :class="['checkbox-button', { active: isSelected }, { cta: isCta }]" @click="select()">
            <span class="checkbox-text">{{ label }}</span>
            <div class="icon" v-show="isSelected">
                <i class="far fa-check"></i>
            </div>
        </div>

        <input type="checkbox" v-model="value" :name="name" />
    </label>
</template>

<script>
import { useStore } from 'vuex'

// lodash components
import _get from 'lodash/get'

export default {
    props: {
        isCta: Boolean,
        name: String,
        label: String,
        vuexKey: String,
    },
    data() {
        return {
            isSelected: false,
        }
    },
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    computed: {
        value: {
            get() {
                return this.store.getters.fieldValue(this.name, this.vuexKey || 'data', !!this.vuexKey)
            },
            set(value) {
                if (this.vuexKey) {
                    this.store.commit('setDataFieldValue', {
                        name: this.name,
                        value: value,
                        key: this.vuexKey,
                    })
                } else {
                    this.store.dispatch('setFieldValue', {
                        name: this.name,
                        value: value,
                    })
                }
            },
        },
    },
    methods: {
        select: function () {
            this.value = !this.value
            this.isSelected = !this.isSelected

            if (this.isSelected) {
                const name = this.name === 'isHomeowner' ? 'isHomeowner' : 'poorCredit'

                this.trackEvent('event', {
                    eventCategory: 'hero-banner-form',
                    eventAction: 'click',
                    eventLabel: name,
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.checkbox-button {
    align-items: center;
    background-color: var(--hero-form-check-button-background);
    border-radius: 4px;
    border: 2px solid var(--hero-form-check-button-border);
    color: var(--hero-form-meta);
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding: 0;
    width: 100%;

    &.cta {
        background-color: var(--cta-form-check-button-color);
        border: 2px solid var(--cta-form-check-button-border);
    }

    .checkbox-text {
        font-size: rem(14px);
        font-weight: 700;
        line-height: rem(40px);
    }

    &:hover {
        transition: all 0.2s;

        &:not(.active) {
            background: var(--hero-form-check-button-hover-background);
            border: 2px solid var(--hero-form-check-button-hover-border);
            filter: brightness(95%);
        }
    }

    &.active {
        background: var(--hero-form-check-button-background);
        border: 2px solid var(--secondary);
        filter: brightness(95%);
        transition: all 0.2s;
    }
}

label {
    margin: 0;
    text-align: center;
    width: 100%;
}

.icon {
    display: none;

    @media screen and (min-width: $bp-medium) {
        color: var(--secondary);
        display: inline-block;
        margin-left: 12px;
    }
}

input[type='checkbox'] {
    display: none;
}
</style>
